export default {
  baseurl: "https://ethiofinanceapi.dev-sh.xyz/api/",
};
